// extracted by mini-css-extract-plugin
export var routingTip = "styles-module__routingTip___Vfihf";
export var textContent = "styles-module__textContent___TDlbg";
export var routingTipTitle = "styles-module__routingTipTitle___EIiBe";
export var routingTipText = "styles-module__routingTipText___AIwi6";